import React from 'react'
import Auth0Wrapper from './Auth0Wrapper'
import OneAuthWrapper from './OneAuthWrapper'

const ProtectedRoute: React.FunctionComponent<any> = ({
  component,
  ...args
}) => {
  const windowObj: any = window

  // One AUTH wrapper
  if (windowObj.REACT_APP_SSO_PROVIDER === 'oneauth') {
    return <OneAuthWrapper Component={component} {...args} />
  } else {
    // AUTH0 wrapper
    return <Auth0Wrapper Component={component} {...args} />
  }
}

export default ProtectedRoute
